import React from "react";
import { Grid, Image } from "semantic-ui-react";
import logo from "../../../assets/img/logo.png";
import { connect } from "react-redux";
const UserWrapper = props => {
  return (
    <div className="login-form">
      <style>{`
      body{
        background-color: #3b88f9
      }
      body > div,
      body > div > div,
      body > div > div > div.login-form {
        height: 100%;
      }
      a{
      color: white;
      font-weight: bold;
    }
    a:hover{
      color: lightgrey;
      font-weight: bold;
    }
    `}</style>
      <Grid
        textAlign="center"
        style={{ height: "100%" }}
        verticalAlign="middle">
        <Grid.Column style={{ maxWidth: 450 }}>
          {!props.headerless && <Image src={logo} centered />}
          {props.children}
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default connect()(UserWrapper);



// WEBPACK FOOTER //
// ./src/users/loggedUser/shared/UserWrapper.js